import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { injectIntl } from 'react-intl'
import { Game } from '../../Core'

import * as MapSelectors from '../../Mars/Map/map.selectors'
import * as MapActions from '../../Mars/Map/map.actions'
import * as tutorialActions from '../tutorial.actions'

import * as tutorialSelectors from '../tutorial.selectors'

import TutorialTilePopup from '../../Mars/Map/MapScreen/TilePopup/TilePopup'

const mapDispatchToProps = (dispatch) => ({
  clearAllPopups: bindActionCreators(Game.actions.clearAllPopups, dispatch),

  removePopup: bindActionCreators(tutorialActions.removePopup, dispatch),
  addScreen: bindActionCreators(tutorialActions.addScreen, dispatch),
  setDisplayingCard: bindActionCreators(MapActions.setDisplayingCard, dispatch),
})

const mapStateToProps = (state) => ({
  selectedTile: MapSelectors.getSelectedTile(state),
  visitorMap: tutorialSelectors.getVisitorMap(state),

  playerList: tutorialSelectors.getPlayerList(state),
  groupData: tutorialSelectors.getGroupData(state),
  selectedBuilding: tutorialSelectors.getBuildingSelected(state),
  displayingBuildingCard: tutorialSelectors.getDisplayingBuildingCard(state),
  types: tutorialSelectors.getBuildingTypes(state),
  userMap: tutorialSelectors.getUserMap(state),
  buildings: tutorialSelectors.getBuildings(state),
  indicators: tutorialSelectors.getIndicatorsObject(state),
  currentPhase: tutorialSelectors.getCurrentPhase(state),
  isTutorial: tutorialSelectors.isTutorialMode(state),
})

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(TutorialTilePopup))
